import * as ActionTypes from "./orderActionTypes";

const initialState = {
    isLoading: false,
    isSaved: false,
    orders: [],
    order: null,
    confirmedOrder: null,
    coupon: null,
    count: 0,
};

export const orderReducer = (state = initialState, action) => {
    switch (action.type) {

        case ActionTypes.GET_ORDER:
            return { ...state, isLoading: true };
        case ActionTypes.GET_ORDER_FAILURE:
            return { ...state, isLoading: false };
        case ActionTypes.GET_ORDER_SUCCESS:
            return { ...state, isLoading: false, orders: action?.payload?.data?.order || [], count: action?.payload?.data?.count || 0 };

        case ActionTypes.GET_ORDER_BY_ID:
            return { ...state, isLoading: true, order: null };
        case ActionTypes.GET_ORDER_BY_ID_FAILURE:
            return { ...state, isLoading: false };
        case ActionTypes.GET_ORDER_BY_ID_SUCCESS:
            return { ...state, isLoading: false, order: action?.payload?.data || null };

        case ActionTypes.UPDATE_ORDER:
            return { ...state, isLoading: true, isSaved: false };
        case ActionTypes.UPDATE_ORDER_FAILURE:
            return { ...state, isLoading: false };
        case ActionTypes.UPDATE_ORDER_SUCCESS:
            return { ...state, isLoading: false, isSaved: true };

        // ✅ Checkout actions
        case ActionTypes.CLEAR_ORDER:
            return { ...state, order: null };

        case ActionTypes.CREATE_ORDER:
            return { ...state, isLoading: true, order: null };
        case ActionTypes.CREATE_ORDER_FAILURE:
            return { ...state, isLoading: false };
        case ActionTypes.CREATE_ORDER_SUCCESS:
            return { ...state, isLoading: false, order: action?.payload?.data || null };

        case ActionTypes.CREATE_ORDER_COD:
            return { ...state, isLoading: true };
        case ActionTypes.CREATE_ORDER_COD_FAILURE:
            return { ...state, isLoading: false };
        case ActionTypes.CREATE_ORDER_COD_SUCCESS:
            return { ...state, isLoading: false, confirmedOrder: action?.payload?.data || null };

        case ActionTypes.CONFIRM_ORDER:
            return { ...state, isLoading: true };
        case ActionTypes.CONFIRM_ORDER_FAILURE:
            return { ...state, isLoading: false };
        case ActionTypes.CONFIRM_ORDER_SUCCESS:
            return { ...state, isLoading: false, confirmedOrder: action?.payload?.data || null };

        case ActionTypes.APPLY_COUPON:
            return { ...state, isLoading: true, coupon: null };
        case ActionTypes.APPLY_COUPON_FAILURE:
            return { ...state, isLoading: false };
        case ActionTypes.APPLY_COUPON_SUCCESS:
            return { ...state, isLoading: false, coupon: action?.payload?.data || null };

        default:
            return state;
    }
};